import { useState } from 'react';
import { marked } from 'marked';

// minimal frontmatter parser
function parseFrontmatterAndContent(text) {
  const regex = /---\s*([\s\S]*?)\s*---\s*([\s\S]*?)(?=(?:---\s*)|$)/g;
  const results = [];
  let match;
  while ((match = regex.exec(text)) !== null) {
    const fmText = match[1].trim();
    const mdText = match[2].trim();

    const fm = {};
    fmText.split(/\r?\n/).forEach((line) => {
      const idx = line.indexOf(':');
      if (idx === -1) return;
      const key = line.slice(0, idx).trim();
      let val = line.slice(idx + 1).trim();
      if (val.startsWith('"') && val.endsWith('"')) val = val.slice(1, -1);
      if (val === 'true') val = true;
      if (val === 'false') val = false;
      fm[key] = val;
    });

    results.push({ frontmatter: fm, markdown: mdText });
  }
  return results;
}

function mdToHtml(md) {
  if (!md) return '';
  // use marked to produce clean HTML
  return marked.parse(md);
}

const MarkdownUploader = ({ onImport }) => {
  const [message, setMessage] = useState('');

  const handleFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      try {
        const parsed = parseFrontmatterAndContent(text);
        if (!parsed.length) {
          setMessage('No articles found in file. Ensure each article has frontmatter between `---` and content.');
          return;
        }
        const articles = parsed.map((p, idx) => {
          const fm = p.frontmatter || {};
          return {
            id: Date.now() + idx,
            title: fm.title || `Imported Article ${idx + 1}`,
            slug: fm.slug || (fm.title ? fm.title.toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-') : `imported-${Date.now() + idx}`),
            date: fm.date || new Date().toISOString().slice(0, 10),
            category: fm.category || 'Uncategorized',
            excerpt: fm.excerpt || '',
            metaDesc: fm.metaDesc || '',
            keywords: fm.keywords || '',
            tags: fm.tags || '',
            featuredImage: fm.featuredImage || '',
            published: fm.published === true || fm.published === 'true' || false,
            content: mdToHtml(p.markdown || ''),
          };
        });

        onImport(articles);
        setMessage(`Imported ${articles.length} article(s) successfully.`);
      } catch (err) {
        console.error(err);
        setMessage('Failed to parse file: ' + err.message);
      }
    };
    reader.readAsText(file, 'utf8');
  };

  return (
    <div className="bg-white rounded-lg shadow p-6 border">
      <label className="block text-sm font-semibold text-gray-700 mb-2">Upload Markdown (.md) file</label>
      <input type="file" accept=".md,text/markdown" onChange={handleFile} />
      {message && <div className="mt-4 text-sm text-gray-700">{message}</div>}
      <div className="mt-3 text-xs text-gray-500">Use the sample file at <strong>docs/import-sample.md</strong> as an example. Each article must have frontmatter wrapped between <code>---</code> and its markdown content following it.</div>
    </div>
  );
};

export default MarkdownUploader;
